module.exports = __webpack_public_path__ + "media/A03.b50f1811.mp4";